const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  tree: state => state.menu.tree,
  currentMenu: state => state.menu.current,
  identity: state => state.identity
}
export default getters
